// #72 Recorded (DC-26): the inline confirmation after a write — a green-rule banner *Recorded · audit event* (the alt
// "receipt" relabelled; pending his wording, Q-E15) and the event's one-line summary. The same event is the newest
// row of the History list. `live` announces it politely (role="status"); it is never a toast.

import type { ReactNode } from "react";
import { Banner } from "../core/Banner";
import { CORE_LABELS } from "../core/labels";
import { cx } from "../lib/cx";

export interface RecordedProps {
  /** The event's one-line summary (a filled template in his words). */
  children?: ReactNode;
  /** Right-aligned meta: the time, a link to the History row. */
  right?: ReactNode | undefined;
  /** Announced when it appears (role="status"). */
  live?: boolean | undefined;
  className?: string | undefined;
}

export function Recorded({ children, right, live, className }: RecordedProps) {
  return (
    <div className={cx("mc-recorded", className)} role={live ? "status" : undefined}>
      <Banner tone="ok" right={right}>
        <b className="mc-recorded-h">{CORE_LABELS.recordedAuditEvent}</b>
        {children !== undefined && children !== null ? <span className="mc-recorded-s">{children}</span> : null}
      </Banner>
    </div>
  );
}
